import { styled } from "@mui/material/styles";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: 24,
  flexDirection: "column",
}));
